/**
 * DataTableProductGroupSortButton
 */

import React from 'react';
import { Icon } from 'ui-component-library/base';

interface Props {
	property: string;

	direction?: string;

	orderByText: string;
	/** Callback for on sort change */
	onChange: any;
}

const DataTableProductGroupSortButton: React.FC<Props> = ({
	property,
	direction,
	onChange,
	orderByText,
	children,
}) => {
	const getNextDirection = () => {
		switch (direction) {
			case 'ASC':
				return 'DESC';
			case 'DESC':
				return '';
			default:
				return 'ASC';
		}
	};
	return (
		<button
			className="font-bold flex items-center"
			onClick={() => onChange(property, getNextDirection())}
		>
			{children}
			<span className="sr-only">{orderByText}</span>
			{direction === 'ASC' ? (
				<Icon
					icon="sortDown"
					size={0.75}
					aria-hidden={true}
					className="ml-2"
					color="#8b8b8b"
				/>
			) : direction === 'DESC' ? (
				<Icon
					icon="sortUp"
					size={0.75}
					aria-hidden={true}
					className="ml-2"
					color="#8b8b8b"
				/>
			) : (
				<Icon
					icon="sort"
					size={0.75}
					aria-hidden={true}
					className="ml-2"
					color="#e1e0de"
				/>
			)}
		</button>
	);
};

export default DataTableProductGroupSortButton;
